import * as React from 'react';

import { UitkText, UitkHeading } from 'uitk-react-text';
import { UitkIcon } from 'uitk-react-icons';
import { UitkCardAlohaContentSection } from 'uitk-react-cards';

import { trackAnalytics } from 'utility';
import { useStores } from 'utility/hooks';
import { Observer } from 'components/shared';
import { FlightsStandardOffer } from '__generated__/api';

interface HygieneAmenitiesProps {
  hygieneAmenities: FlightsStandardOffer.HygieneAmenitiesPresentation;
}

export const HygieneAmenities = ({ hygieneAmenities }: HygieneAmenitiesProps) => {
  const { analytics } = useStores();
  const { airlineAmenityGroups, disclaimerMessage, displayAction } = hygieneAmenities;
  const { onViewedAnalytics } = displayAction;
  const { amenities } = airlineAmenityGroups[0];

  const intersectionAction = () => {
    trackAnalytics(onViewedAnalytics, analytics);
  };

  return (
    <UitkCardAlohaContentSection border="top">
      <div className="all-x-margin-four all-y-margin-four" data-test-id="hygiene-amenities">
        <Observer intersectionAction={intersectionAction}>
          <UitkHeading level={2} size={300}>
            {displayAction?.heading}
          </UitkHeading>
        </Observer>
        <ul role="list" className="all-t-margin-four no-bullet">
          {amenities.map(({ icon, label }, amenityIndex) => (
            <li key={amenityIndex} role="listitem" className="all-t-margin-two all-l-margin-one">
              <UitkIcon name={icon.id} aria-hidden={true} />
              <UitkText size={200} inline className="all-l-margin-two">
                {label}
              </UitkText>
            </li>
          ))}
        </ul>
        <UitkText size={300} className="all-t-margin-four">
          {disclaimerMessage}
        </UitkText>
      </div>
    </UitkCardAlohaContentSection>
  );
};
